import reducer from "./reducer";
export { default as SpecialProcessDefinitionParameters } from "./components/index";
export { default as specialProcessDefinitionParametersReducerName } from "./constants";
export default reducer;
